import Swiper from "swiper";

export default class {

    constructor(elem, param = {}) {
        this.domElem = elem;
        this.arSwiperContainers = elem.querySelectorAll('.swiper-container');
        this.params = {
            speed: param.speed || 650,
            spaceBetween: param.spaceBetween || 20,
            slidesPerView: param.slidesPerView || 1,
            loop: param.loop || true,
            autoHeight:true
        };

        this.params = Object.assign(this.params, param);

        this.arSliderNavigation = elem.querySelectorAll('.js-slider-navigation');

        if (this.arSwiperContainers) {
            this.arSwiperContainers.forEach(($swiperContainer) => {
                this.createSlider($swiperContainer);
            });
        }
    }

    createSlider($swiperContainer) {
        let $PrevArrow = this.domElem.querySelector('.js-slide-prev'),
            $NextArrow = this.domElem.querySelector('.js-slide-next'),
            $pagination = this.domElem.querySelector('.js-pagination');
        if(window.outerWidth<=990 && this.domElem.classList.contains('js-adaptive-control')) {
            $PrevArrow = this.domElem.querySelector('.js-slide-prev-adaptive');
            $NextArrow = this.domElem.querySelector('.js-slide-next-adaptive');
        }
        if ($PrevArrow && $NextArrow) {
            this.params.navigation = {
                nextEl: $NextArrow,
                prevEl: $PrevArrow,
            };
        }
        if ($pagination) {
            this.params.pagination = {
                el: $pagination,
                clickable: true
            };
        }
        this.sliderExample = new Swiper($swiperContainer, this.params);
    }


}


// WEBPACK FOOTER //
// ../templates/blocks/slider/_class.js